import { queryDomainThemeByDomain } from '@/api/basic/domainTheme'
import { getDomainTheme, setDomainTheme } from '@/utils/localStorage'
import axios from 'axios'
import cssColorFunction from 'css-color-function'
import themes from './themes.json'

const formula = {
  'shade-1': 'color(primary shade(10%))',
  'light-1': 'color(primary tint(10%))',
  'light-2': 'color(primary tint(20%))',
  'light-3': 'color(primary tint(30%))',
  'light-4': 'color(primary tint(40%))',
  'light-5': 'color(primary tint(50%))',
  'light-6': 'color(primary tint(60%))',
  'light-7': 'color(primary tint(70%))',
  'light-8': 'color(primary tint(80%))',
  'light-9': 'color(primary tint(90%))'
}

const elementDefaultThemes = {
  '#3a8ee6': 'shade-1',
  '#409eff': 'primary',
  '#53a8ff': 'light-1',
  '#66b1ff': 'light-2',
  '#79bbff': 'light-3',
  '#8cc5ff': 'light-4',
  '#a0cfff': 'light-5',
  '#b3d8ff': 'light-6',
  '#c6e2ff': 'light-7',
  '#d9ecff': 'light-8',
  '#ecf5ff': 'light-9'
}

const generateColors = (primary) => {
  let colors = {}

  Object.keys(formula).forEach((key) => {
    const value = formula[key].replace(/primary/g, primary)
    colors[key] = cssColorFunction.convert(value)
  })
  return colors
}

/**
 * 16进制转rgba
 * @param {string} color
 * @param {Float32Array} color
 * @returns
 */
const hex2rgba = (color, opacity = 1) => {
  //
  if (color.includes('rgb')) return color
  color = color.replace('#', '').trim()
  if (color.length === 3) {
    color = color
      .split('')
      .map((item) => item.padStart(2, item))
      .join('')
  }
  const rgbaColor = `rgba(${parseInt(color.substring(0, 2), 16)}, ${parseInt(color.substring(2, 4), 16)}, ${parseInt(color.substring(4), 16)}, ${opacity})`
  return rgbaColor
}

const setCssRootVar = (primaryColor) => {
  if (!primaryColor.includes('#') && !primaryColor.includes('rgb')) {
    // throw new Error('主题色需要使用16进制或rgb格式')
    console.error('主题色需要使用16进制或rgb格式')
    return
  }
  const cssVar = {
    '--primary-color': primaryColor,
    '--primary-hover-color': hex2rgba(primaryColor, 0.4),
    '--primary-disabled-color': hex2rgba(primaryColor, 0.7)
  }
  Object.keys(cssVar).forEach((key) => {
    document.querySelector(':root').style.setProperty(key, cssVar[key])
  })
}

const switchTheme = async (themeKey = 'blue') => {
  let domainTheme = getDomainTheme()
  if (!domainTheme) {
    // 请求主题域名
    await queryDomainThemeByDomain()
      .then((res) => {
        try {
          domainTheme = JSON.parse(res.data.config)
          setDomainTheme(domainTheme)
        } catch (e) {
          console.log('e :', e)
        }
      })
      .catch((e) => e)
  }

  const newTheme = themes.find((item) => item.key === (themeKey || domainTheme?.theme || 'blue'))

  if (!newTheme) return

  console.log(newTheme, 'newTheme')

  const colorMaps = Object.assign({ primary: newTheme.color }, generateColors(newTheme.color))

  const defaultThemeUrl = document.querySelector('link[href*="chunk-element-ui"]')?.href
  if (!defaultThemeUrl) return

  return axios({
    url: defaultThemeUrl
  }).then((res) => {
    /** @type {string} */
    const defaultThemeCode = res.data
    let themeCode = defaultThemeCode
    Object.keys(elementDefaultThemes).forEach((key) => {
      const value = colorMaps[elementDefaultThemes[key]]
      themeCode = themeCode.replace(new RegExp(key, 'ig'), value)
    })
    let style = document.head.querySelector('style[id="custom-theme"]') || document.createElement('style')
    style.innerText = themeCode
    if (!style.getAttribute('id')) {
      style.setAttribute('id', 'custom-theme')
      style.type = 'text/css'
      document.head.appendChild(style)
    }
    setCssRootVar(colorMaps.primary)
    domainTheme.theme = newTheme.key
    setDomainTheme(domainTheme)
  })
}

export { switchTheme }
